import { HelpContentComponent, HelpContentRendererValue } from '../../../UI-Lib/Help-Tooltip';
import { Component } from '@angular/core';

export interface ReturnBatchTaxYearAdditionalInfoComponentParams extends HelpContentRendererValue<any> {
    lienDate: Date;
    cutOffDate: Date;
    changeDetection: string;
    ages: string[];
}

@Component({
    selector: 'return-batch-tax-year-additional-info',
    template: `
        <table>
          <tr>
            <td class="info-label">Lien Date:</td>
            <td>{{ params.lienDate | weissmanDateFormat }}</td>
          </tr>
          <tr>
            <td class="info-label">Cut Off Date:</td>
            <td>{{ params.cutOffDate | weissmanDateFormat }}</td>
          </tr>
          <tr>
            <td class="info-label">Change:</td>
            <td>{{ params.changeDetection }}</td>
          </tr>
          @for (age of params.ages; track age; let i = $index) {
            <tr>
              <td class="info-label">Age {{i + 1}}:</td>
              <td>{{ age }}</td>
            </tr>
          }
        </table>
        `,
    styles: ['.info-label {font-weight: bold; padding-right: 5px;}'],
    standalone: false
})
export class ReturnBatchTaxYearAdditionalInfoComponent implements HelpContentComponent<ReturnBatchTaxYearAdditionalInfoComponentParams> {
    params: ReturnBatchTaxYearAdditionalInfoComponentParams;

    helpInit(params: ReturnBatchTaxYearAdditionalInfoComponentParams): void {
    }
}
